module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "print-dialog"
  }, [_c('div', {
    staticClass: "hero print-header"
  }, [_c('div', {
    staticClass: "hero-body"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v("\n                    Printing " + _vm._s(_vm.originalItems.length) + " " + _vm._s(_vm._f("pluralize")(_vm.originalItems.length, _vm.type)) + "\n                    "), (!_vm.showPrintConfirmation && _vm.originalItems.length >= 15) ? _c('div', {
    staticClass: "is-pulled-right has-text-right"
  }, [_c('button', {
    staticClass: "button is-dark",
    attrs: {
      "title": "DOESN'T MARK AS PRINTED"
    },
    on: {
      "click": function($event) {
        return _vm.cleanup(false)
      }
    }
  }, [_vm._v("\n                            Cancel "), _c('i', {
    staticClass: "fa fa-close"
  })]), _vm._v(" "), _c('button', {
    staticClass: "button is-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.startPrint()
      }
    }
  }, [_vm._v("START")])]) : _vm._e()]), _vm._v(" "), (_vm.type === 'order' && _vm.originalItems.length >= 15) ? _c('small', {
    staticClass: "has-text-centered is-block"
  }, [_vm._v("\n                    Click "), _c('strong', [_vm._v("START")]), _vm._v(" to begin printing the " + _vm._s(_vm.originalItems.length) + " " + _vm._s(_vm._f("pluralize")(_vm.originalItems.length, _vm.type)) + "\n                ")]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "print-container"
  }, [(_vm.type === 'order') ? _c('span', _vm._l((_vm.originalItems), function(order) {
    return (_vm.printItems.length === 0 || _vm.printItems.indexOf(order) !== -1) ? _c('order', {
      key: order.id,
      attrs: {
        "order-id": order.id
      }
    }) : _vm._e()
  }), 1) : _vm._e(), _vm._v(" "), (_vm.type === 'request') ? _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "title is-4 has-text-centered"
  }, [_vm._v("\n                Catalog Requests - " + _vm._s(_vm.$store.state.company.name) + "\n            ")]), _vm._v(" "), _c('table', {
    staticClass: "table is-fullwidth"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.originalItems), function(request) {
    return (_vm.printItems.length === 0 || _vm.printItems.indexOf(request) !== -1) ? _c('tr', {
      key: request.id
    }, [_c('td'), _vm._v(" "), _c('td', [_vm._v(_vm._s(request.company))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(request.referrer))]), _vm._v(" "), _c('td', [_vm._v("\n                        " + _vm._s(request.first_name) + " " + _vm._s(request.last_name) + "\n                        "), (request.email) ? _c('br') : _vm._e(), _vm._v("\n                        " + _vm._s(request.email) + "\n                        "), (request.phone) ? _c('br') : _vm._e(), _vm._v("\n                        " + _vm._s(_vm._f("phone")(request.phone)) + "\n                    ")]), _vm._v(" "), _c('td', [_vm._v("\n                        " + _vm._s(request.line1) + "\n                        "), (request.line2) ? _c('br') : _vm._e(), _vm._v("\n                        " + _vm._s(request.line2) + "\n                        "), _c('br'), _vm._v("\n                        " + _vm._s(request.city) + ", " + _vm._s(request.state) + " " + _vm._s(request.zip) + "\n                        " + _vm._s(request.country !== 'United States' ? request.country : '') + "\n                    ")]), _vm._v(" "), _c('td', [_vm._v("\n                        " + _vm._s(_vm._f("moment")(request.created_at, 'MM/DD/YY - h:mm A')) + "\n                    ")])]) : _vm._e()
  }), 0)])]) : _vm._e()]), _vm._v(" "), (_vm.showPrintConfirmation) ? _c('div', {
    staticClass: "print-confirmation"
  }, [(_vm.type === 'order') ? _c('div', {
    staticClass: "print-confirmation-dialog"
  }, [(_vm.printSuccess === true) ? _c('button', {
    staticClass: "button is-pulled-right is-danger",
    attrs: {
      "title": "DON'T MARK ANYTHING AS PRINTED"
    },
    on: {
      "click": function($event) {
        return _vm.cleanup(false)
      }
    }
  }, [_vm._v("\n                Cancel Print "), _c('i', {
    staticClass: "fa fa-close"
  })]) : _vm._e(), _vm._v(" "), (_vm.printSuccess === false) ? _c('button', {
    staticClass: "button is-pulled-right",
    attrs: {
      "title": "DON'T MARK ANYTHING AS PRINTED"
    },
    on: {
      "click": function($event) {
        _vm.printSuccess = true
      }
    }
  }, [_vm._v("Go Back")]) : _vm._e(), _vm._v(" "), _c('h2', {
    staticClass: "title"
  }, [_vm._v("Print Confirmation")]), _vm._v(" "), (_vm.printSuccess === true) ? _c('p', {
    staticClass: "has-text-centered title is-5"
  }, [_vm._v("\n                Did all "), _c('b', [_vm._v(_vm._s(_vm.originalItems.length))]), _vm._v(" " + _vm._s(_vm._f("pluralize")(_vm.originalItems.length, 'order')) + " print?\n                "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('button', {
    staticClass: "button",
    on: {
      "click": function($event) {
        return _vm.cleanup(true)
      }
    }
  }, [_vm._v("Yes, mark everything as printed.")]), _vm._v(" "), _c('button', {
    staticClass: "button",
    on: {
      "click": function($event) {
        _vm.printSuccess = false
      }
    }
  }, [_vm._v("No, some or all did not print.")])]) : _vm._e(), _vm._v(" "), (_vm.printSuccess === false) ? _c('div', [_c('p', {
    staticClass: "has-text-centered"
  }, [_vm._v("Select which orders did not print")]), _vm._v(" "), _c('div', {
    staticClass: "print-contents"
  }, _vm._l((_vm.originalItems), function(order) {
    return _c('div', {
      staticClass: "print-content"
    }, [_c('label', {
      staticClass: "checkbox",
      staticStyle: {
        "width": "100%"
      },
      attrs: {
        "for": 'order' + order.id
      }
    }, [_c('input', {
      attrs: {
        "type": "checkbox",
        "id": 'order' + order.id
      },
      domProps: {
        "value": order.id,
        "checked": _vm.printItems.indexOf(order) !== -1
      },
      on: {
        "click": function($event) {
          return _vm.togglePrintItem(order)
        }
      }
    }), _vm._v("\n                            " + _vm._s(order.company) + " - " + _vm._s(order.id) + "\n                        ")])])
  }), 0), _vm._v(" "), (_vm.printItems.length === 0) ? _c('button', {
    staticClass: "button",
    on: {
      "click": function($event) {
        return _vm.selectAll()
      }
    }
  }, [_vm._v("Select All")]) : _c('button', {
    staticClass: "button",
    on: {
      "click": function($event) {
        return _vm.selectNone()
      }
    }
  }, [_vm._v("Deselect All")]), _vm._v(" "), (_vm.printItems.length > 0) ? _c('div', {
    staticClass: "is-pulled-right"
  }, [_c('button', {
    staticClass: "button is-primary",
    on: {
      "click": function($event) {
        return _vm.cleanup(false)
      }
    }
  }, [_vm._v("\n                        Reprint the selected orders\n                    ")])]) : _vm._e()]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.type === 'request') ? _c('div', {
    staticClass: "print-confirmation-dialog"
  }, [_c('h2', {
    staticClass: "title"
  }, [_vm._v("Print Confirmation")]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "is-clearfix"
  }, [_c('button', {
    staticClass: "button is-pulled-left",
    attrs: {
      "title": "DON'T MARK ANYTHING AS PRINTED"
    },
    on: {
      "click": function($event) {
        return _vm.cleanup(false)
      }
    }
  }, [_vm._v("Cancel Print  "), _c('i', {
    staticClass: "fa fa-close"
  })]), _vm._v(" "), _c('button', {
    staticClass: "button is-primary is-pulled-right",
    on: {
      "click": function($event) {
        return _vm.cleanup(true)
      }
    }
  }, [_vm._v("\n                    FINISH PRINT\n                ")])])]) : _vm._e()]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Entered")]), _vm._v(" "), _c('th', [_vm._v("Company")]), _vm._v(" "), _c('th', [_vm._v("Referrer")]), _vm._v(" "), _c('th', [_vm._v("Contact")]), _vm._v(" "), _c('th', [_vm._v("Address")]), _vm._v(" "), _c('th', [_vm._v("Requested")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "has-text-centered"
  }, [_c('p', [_vm._v("Click "), _c('strong', [_vm._v("FINISH PRINT")]), _vm._v(" to mark the catalog requests as printed.")]), _vm._v(" "), _c('p', [_vm._v("Click "), _c('strong', [_vm._v("CANCEL PRINT")]), _vm._v(" to not mark anything as printed.")]), _vm._v(" "), _c('br')])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-cff75284"}!./~/vue-loader/lib/selector.js?type=template&index=0!./vue/src/components/PrintDialog.vue
// module id = 579
// module chunks = 0